import React from 'react';
import { useNavigate } from 'react-router-dom';
import './OutplacementServices.css';

function OutplacementServices() {
  const navigate = useNavigate();

  const handleLetsTalk = () => {
    navigate('/contact?topic=outplacement');
  };

  return (
    <div className="outplacement-page">
      {/* Hero Section */}
      <section className="outplacement-hero">
        <div className="hero-content">
          <h1>Outplacement Services</h1>
          <p className="hero-subtitle">
            Comprehensive career transition support for organizations and individuals
          </p>
          <p className="hero-description">
            We provide comprehensive career transition support powered by AI technology. 
            Our services include resume optimization and improving your overall experience for finding jobs.
          </p>
        </div>
      </section>

      {/* What We Offer Section */}
      <section className="services-section">
        <h2>What We Offer</h2>
        <div className="services-grid">
          <div className="service-card">
            <h3>Job Searching Strategies</h3>
            <p>Personalized job search plans and networking support</p>
          </div>
          <div className="service-card">

            <h3>Autofilling for Resume Pages</h3>
            <p>AI-powered form filling for job applications</p>
          </div>
          <div className="service-card">
            <h3>Storing and Tracking</h3>
            <p>Organize and track all job postings in one place</p>
          </div>
          <div className="service-card">
            <h3>Streamlined Experience</h3>
            <p>Making your job searching experience easier</p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <h2>Why Choose JobQue.ai?</h2>
        <div className="benefits-list">
          <div className="benefit-item">
            <div className="benefit-icon">⚡</div>
            <div className="benefit-content">
              <h3>Faster Job Placement</h3>
              <p>Our AI-powered tools help candidates apply to more jobs in less time</p>
            </div>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">💡</div>
            <div className="benefit-content">
              <h3>Easy to Use</h3>
              <p>Simple, intuitive platform that requires minimal training</p>
            </div>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">📈</div>
            <div className="benefit-content">
              <h3>Track Progress</h3>
              <p>Monitor application status and job search progress in real-time</p>
            </div>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">🤝</div>
            <div className="benefit-content">
              <h3>Support Your Team</h3>
              <p>Show your employees you care about their career transition</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <h2>How It Works</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Sign Up</h3>
            <p>Employees create their free account and upload their resume</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Search & Save</h3>
            <p>Browse job postings and save opportunities with one click</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Auto-Apply</h3>
            <p>Use AI to automatically fill job application forms</p>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <h3>Track & Manage</h3>
            <p>Monitor all applications and follow-ups in one dashboard</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready to Support Your Team?</h2>
          <p>Let's discuss how JobQue.ai can help your organization with outplacement services</p>
          <button className="lets-talk-btn" onClick={handleLetsTalk}>
            Let's Talk
          </button>
        </div>
      </section>
    </div>
  );
}

export default OutplacementServices;